// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"CardSkeleton_skeletonContainer__AJTn9","skeletonCard":"CardSkeleton_skeletonCard__J0rYi"};